<template>
    <div class="travel-radar-legend">
        <div class="travel-radar-legend__item" v-for="(item, index) in legend" :key="index">
            <div class="travel-radar-legend__item__image">
                <img :src="item.image" :alt="item.label">
            </div>
            <div class="black copy">{{ item.label }}</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            legend: [
                {
                    label: 'sehr geringes Risiko, kaum Auswirkungen',
                    image: `${process.env.BASE_URL}/images/poi-icons/travelRadar/symbol/icon-very-weak.svg`
                },
                {
                    label: 'geringes Risiko, wenige Auswirkungen',
                    image: `${process.env.BASE_URL}/images/poi-icons/travelRadar/symbol/icon-weak.svg`
                },
                {
                    label: 'erhöhtes Risiko, spürbare Auswirkungen',
                    image: `${process.env.BASE_URL}/images/poi-icons/travelRadar/symbol/icon-mid.svg`
                },
                {
                    label: 'hohes Risiko, starke Auswirkungen',
                    image: `${process.env.BASE_URL}/images/poi-icons/travelRadar/symbol/icon-high.svg`
                },
                {
                    type: 'very-high',
                    label: 'sehr hohes Risiko, massive Auswirkungen',
                    image: `${process.env.BASE_URL}/images/poi-icons/travelRadar/symbol/icon-very-high.svg`
                },
            ],
        }
    }
}
</script>

<style lang="scss">
.travel-radar-legend {
    &__item {
        display: flex;
        align-items: center;
        padding: 3px 0;

        &__image {
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            width: 24px;
            height: 24px;
            margin-right: 16px;
            line-height: 0;
        }
    }
}
</style>